import { NgModule } from '@angular/core';
import { SiteContextEventBuilder } from './site-context-event.builder';

@NgModule({})
export class SiteContextEventModule {
  constructor(_siteContextEventBuilder: SiteContextEventBuilder) {}
}
